import React from 'react';
import { InspirationalSearchSelector } from './InspirationalSearchSelector';

export function InspirationalSearchSelectorSource() {
    return {
        render: ({
            onClickItem,
            trackAutocompleteSourceState,
            trackAutocompleteSourceSelection,
        } = {}) => {
            return (
                <InspirationalSearchSelector
                    key="inspirational-selector"
                    onClickItem={onClickItem}
                    trackAutocompleteSourceState={trackAutocompleteSourceState}
                    trackAutocompleteSourceSelection={trackAutocompleteSourceSelection}
                />
            );
        },
    };
}
